module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('my-panel', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7a6abd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Admin.vue
// module id = 1710
// module chunks = 1